<template>
  <section class="container-wrapper error-page">
    <h1 v-if="title" class="error-page__title">
      {{ title }}
    </h1>
    <p class="error-page__text">
      {{ text }}
    </p>
    <div
      v-show="buttonText"
      class="error-page__button-wrapper"
    >
      <BaseButton
        type="primary"
        class="error-page__button"
        @click="navigateHome"
      >
        {{ buttonText }}
        <IconArrow class="icon-left" />
      </BaseButton>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { get } from 'lodash'
  import IconArrow from '@/assets/img/icons/arrow-long-right.svg?inline'

  export default {
    name: 'NotFoundPage',
    components: {
      IconArrow
    },
    data () {
      return {
        from404: {}
      }
    },
    computed: {
      ...mapState(['main', 'globalData']),
      title () {
        return get(this.$route, 'params.title') || get(this, 'main.notFound.title')
      },
      text () {
        return get(this.$route, 'params.description') || get(this, 'main.notFound.description')
      },
      buttonText () {
        return get(this.$route, 'params.buttonText') || get(this, 'main.notFound.button')
      }
    },
    methods: {
      navigateHome () {
        if (get(this.$route, 'params.goBack') === true) {
          // this.$router.go(-1)
          this.$router.push('/service')
          return
        }
        this.$router.push('/service')
      }
    }
  }
</script>

<style lang="scss">
  .error-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100vh;

    .icon-left {
      position: relative;
      top: -1px;
      height: 14px;
      margin-left: 8px;
      color: $c-white;
    }

    .button {
      width: unset !important;
    }

    &__title {
      color: #1a1a1f;
    }

    &__text {
      color: #1a1a1f;
      text-align: center;
    }

    &__button {
      margin-top: 50px;

      @include mobile {
        margin-top: 25px;
      }

      &-wrapper {
        display: flex;
        justify-content: center;
      }
    }
  }
</style>
